import { PageLayout } from "@/shared/ui/layouts/PageLayout";
// import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
// import Typography from "@/shared/ui/Typography";
import * as React from "react";

import { MortgageSection } from "../../../widgets/mortgage_section/ui";
import { GetBestApplicationSection } from "@/widgets/get_best_application/ui";
import { useScrollToTop } from "@/shared/hooks/useScrollToTop";
import { MapFilterSection } from "./sections/MapFilterSection";

export function CatalogPage() {
    const scrollToTop = useScrollToTop();
    const spaceRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const resize = () => {
            const header = document.getElementById("header_id");
            if (!header || !spaceRef.current) return;

            const height = header.offsetHeight;
            spaceRef.current.style.height = `${height}px`;
        };

        window.addEventListener("resize", resize);

        resize();
        scrollToTop();

        return () => {
            window.removeEventListener("resize", resize);
        };
    }, [scrollToTop]);

    return (
        <PageLayout>
            <div ref={spaceRef} />
            <MapFilterSection />
            <GetBestApplicationSection />
            <MortgageSection />
        </PageLayout>
    );
}
